/**
 * 클립보드에 텍스트를 복사하는 함수.
 * navigator.clipboard.writeText를 우선적으로 시도하고, 실패 시 document.execCommand를 사용한 대체 방법을 사용합니다.
 * @param {string} item - 복사된 아이템 타이틀
 * @param {string} text - 복사할 텍스트
 */
export async function copyToClipboard(item, text) {
    try {
        // navigator.clipboard는 https 또는 localhost 환경에서만 사용 가능합니다.
        if (navigator.clipboard && window.isSecureContext) {
            await navigator.clipboard.writeText(text);

            alert(`${item} 클립보드에 복사되었습니다.`);
            return true;
        } else {
            // https가 아닌 환경을 위한 대체 방법
            return fallbackCopyToClipboard(item, text);
        }
    } catch (err) {
        console.error("클립보드 복사 실패:", err);
        return fallbackCopyToClipboard(item, text); // navigator.clipboard.writeText 실패 시 대체 방법 실행
    }
}

/**
 * document.execCommand를 사용한 클립보드 복사 대체 함수.
 * @param {string} item - 복사된 아이템 타이틀
 * @param {string} text - 복사할 텍스트
 */
function fallbackCopyToClipboard(item, text) {
    let textArea;
    try {
        const activeEl = document.activeElement;
        const root = activeEl && activeEl.shadowRoot ? activeEl.shadowRoot : document.body;

        textArea = document.createElement("textarea");
        textArea.value = text;
        // 화면에 보이지 않게 처리
        textArea.style.position = "fixed";
        textArea.style.opacity = "0";
        root.appendChild(textArea);

        textArea.focus();
        textArea.select(); // 텍스트를 선택 상태로 만듦

        // 복사 명령 실행
        const success = document.execCommand("copy");
        if (success) {
            alert(`${item} 클립보드에 복사되었습니다.`);
        } else {
            console.error("클립보드 복사 실패 (fallback)");
            alert("클립보드 복사에 실패했습니다.");
        }
        return success;
    } catch (err) {
        console.error("execCommand 복사 중 오류 발생:", err);
        alert("클립보드 복사 중 오류가 발생했습니다.");
        return false;
    } finally {
        if (textArea) {
            // document.body.removeChild(textArea); // 생성한 요소 제거
            textArea.parentNode.removeChild(textArea);
        }
    }
}
